import { useSoftwareVersion } from 'src/Libs/home-power-station'
import { isFlowTheme } from 'src/Libs/utils'
import { getDynamicEmsAccessibility } from '../../utils'

export interface DynamicEmsAccessibleReturnType {
  isDynamicEmsAccessible: boolean
  isDynamicEmsV2Accessible: boolean
}

/**
 * Returns whether the dynamic ems feature is accessible for the user/installation
 */
const useIsDynamicEmsAccessible = (): DynamicEmsAccessibleReturnType => {
  const { softwareVersion } = useSoftwareVersion()

  return getDynamicEmsAccessibility(softwareVersion, isFlowTheme)
}

export default useIsDynamicEmsAccessible
